import type { WorkflowScenario } from '@chatsdet/types';

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function extractScenarioImportItems(raw: unknown): unknown[] | null {
  if (Array.isArray(raw)) return raw;
  if (!isRecord(raw)) return null;

  if (Array.isArray(raw.scenarios)) return raw.scenarios;
  if (Array.isArray(raw.scenariosJson)) return raw.scenariosJson;

  const example = raw.example;
  if (isRecord(example) && Array.isArray(example.scenarios)) {
    return example.scenarios;
  }

  const workflow = raw.workflow;
  if (isRecord(workflow)) {
    if (Array.isArray(workflow.scenariosJson)) return workflow.scenariosJson;
    if (Array.isArray(workflow.scenarios)) return workflow.scenarios;
  }

  return null;
}

export function parseScenarioImportPayload(
  raw: unknown,
  createId: () => string = () => crypto.randomUUID()
): WorkflowScenario[] | null {
  const items = extractScenarioImportItems(raw);
  if (!items) return null;

  const scenarios: WorkflowScenario[] = [];
  for (const item of items) {
    if (!isRecord(item) || typeof item.name !== 'string' || !item.name.trim()) {
      return null;
    }

    const id = typeof item.id === 'string' && item.id ? item.id : createId();
    const scenario: WorkflowScenario = {
      id,
      name: item.name.trim(),
      description: typeof item.description === 'string' ? item.description : undefined,
      isDefault: typeof item.isDefault === 'boolean' ? item.isDefault : undefined,
      includeInSuite:
        typeof item.includeInSuite === 'boolean' ? item.includeInSuite : undefined,
      values: isRecord(item.values)
        ? ({ ...item.values } as WorkflowScenario['values'])
        : undefined,
      credentials: isRecord(item.credentials)
        ? ({ ...item.credentials } as WorkflowScenario['credentials'])
        : undefined,
    };
    scenarios.push(scenario);
  }

  return scenarios;
}
